/** Keep in sync with apps/backend-nest/src/registration/registration-file-limits.ts */
export const REGISTRATION_PROFILE_PHOTO_MAX_BYTES = 2 * 1024 * 1024;
export const REGISTRATION_DOCUMENT_MAX_BYTES = 5 * 1024 * 1024;

function formatMaxSize(bytes: number): string {
  const mb = bytes / (1024 * 1024);
  return `${Number.isInteger(mb) ? mb.toFixed(0) : mb.toFixed(1)} MB`;
}

function formatByteSize(bytes: number): string {
  const mb = bytes / (1024 * 1024);
  if (mb >= 1) {
    const rounded = Math.round(mb * 10) / 10;
    return `${Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(1)} MB`;
  }
  const kb = bytes / 1024;
  if (kb >= 1) {
    const rounded = Math.round(kb * 10) / 10;
    return `${Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(1)} KB`;
  }
  return `${bytes} B`;
}

export const REGISTRATION_PROFILE_PHOTO_MAX_LABEL = formatMaxSize(
  REGISTRATION_PROFILE_PHOTO_MAX_BYTES
);
export const REGISTRATION_DOCUMENT_MAX_LABEL = formatMaxSize(REGISTRATION_DOCUMENT_MAX_BYTES);

export const REGISTRATION_UPLOAD_TOO_LARGE_MESSAGE = `The uploaded file is too large. Profile pictures must be ${REGISTRATION_PROFILE_PHOTO_MAX_LABEL} or smaller, and documents must be ${REGISTRATION_DOCUMENT_MAX_LABEL} or smaller. Choose a smaller file and try again.`;

export function registrationFileSizeError(
  file: { name: string; size: number },
  kind: "photo" | "document",
  label?: string
): string | null {
  const limit =
    kind === "photo" ? REGISTRATION_PROFILE_PHOTO_MAX_BYTES : REGISTRATION_DOCUMENT_MAX_BYTES;
  if (file.size <= limit) return null;
  const subject = label?.trim() || (kind === "photo" ? "Profile picture" : "Document");
  const maxLabel =
    kind === "photo" ? REGISTRATION_PROFILE_PHOTO_MAX_LABEL : REGISTRATION_DOCUMENT_MAX_LABEL;
  return `${subject} "${file.name}" is ${formatByteSize(file.size)}, which is larger than the maximum of ${maxLabel}. Choose a smaller file and try again.`;
}
